import KeyedDto from '../KeyedDto';

export class FileNameDto extends KeyedDto {
	/**
	 * @module FileNameDto
	 */
	constructor() {
		super();
		/** @type {string} */
		this.fileName = null;
	}

	/**
	 * @typedef {Object} _FileNameDtoProps
	 * @property {string} fileName
	 *
	 * @typedef {import("../KeyedDto").KeyedDtoProps & _FileNameDtoProps} FileNameDtoProps
	 */
	/**
	 *
	 * @param {FileNameDtoProps} props
	 * @returns {FileNameDto}
	 */
	setup(props) {
		super.setup(props);
		this.fileName = props.fileName;
		return this;
	}
}

export default FileNameDto;
